export enum SizeSliderType {
	SMALL = 'S',
	MEDIUM = 'M',
	LARGE = 'L'
}
